import FormControlLabel from '@material-ui/core/FormControlLabel'
import { withStyles } from '@material-ui/core/styles'

const BccFormControlLabel = withStyles({
  root: {
    fontSize: 16,
  },
})(FormControlLabel)

export default BccFormControlLabel
